import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import AnnouncementBar from "@/components/AnnouncementBar";
import SaleBanner from "@/components/SaleBanner";
import Footer from "@/components/Footer";
import SocialProofGlobal from "@/components/SocialProofGlobal";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import BankInstructions from "@/pages/BankInstructions";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Disclaimer from "@/pages/Disclaimer";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

export default function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <SmoothScroll>
              <SaleBanner />
              <AnnouncementBar />
              <Nav />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:slug" element={<Product />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/instructions/:ref" element={<BankInstructions />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
              </Routes>
              <Footer />
              <SocialProofGlobal />
              <ExitIntentPopup />
              <Toaster position="bottom-right" richColors />
            </SmoothScroll>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
